<template>
    <div class="o-news u-w100 u-py20 u-overflowYAuto">
        <div class="o-news__inner u-container u-overflowHidden">
            <div class="o-news__news">
                <Article v-for="newsItem in news" :key="newsItem.id" :item="newsItem" type="news" />
                <div v-if="noMoreArticles" class="no-more-articles">{{ $t('knowledgebase.noMoreArticles') }}</div>
                <div ref="trigger" class="o-news__trigger u-mt50"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import api from '../services/api';
import Article from '../components/molecules/Article.vue';

const news = ref([]);
const noMoreArticles = ref(false);
const offset = ref(0);
const number = ref(8);
const loading = ref(false);
const observer = ref(null);
const trigger = ref(null);

const emit = defineEmits(['updateHeader']);

const loadMoreArticles = async () => {
    try {
        const response = await api.get(`/news?offset=${offset.value}&number=${number.value}`);
        if (response.data.message) {
            noMoreArticles.value = true;
        } else {
            const newNews = response.data.map(newsItem => ({
                id: newsItem.id,
                image: newsItem.image,
                title: newsItem.title,
                date: newsItem.date,
            }));
            news.value.push(...newNews);
            offset.value += number.value;
        }
    } catch (error) {
        console.error('Error loading news:', error);
    }
};

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !noMoreArticles.value && !loading.value) {
            loading.value = true;
            loadMoreArticles();
            loading.value = false;
        }
    });
    observer.value.observe(trigger.value);
};

onMounted(async () => {
    await nextTick();
    setupObserver();
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});
</script>
